module.exports = __webpack_public_path__ + "img/logocirculo.c2169bab.png";